import { useState } from "react";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import Buttons from "../../../components/Buttons/Buttons";
import TextInput from "../../../components/TextInput/TextInput";
import { CARD_HEADER_LABELS, CHOICE_QUESTION_TYPES, QUESTION_TYPES } from "../../../utils/surveysConstants";

const SurveyQuestionCard = ({ question, index, isFirst, isLast, onUpdate, onRemove, onMove }) => {
  const isSection = question.type === QUESTION_TYPES.SECTION;
  const isInstruction = question.type === QUESTION_TYPES.INSTRUCTION;
  const isStructural = isSection || isInstruction;
  const isChoice = CHOICE_QUESTION_TYPES.includes(question.type);
  const isRating = question.type === QUESTION_TYPES.RATING;

  const [optionsInput, setOptionsInput] = useState(() => (question.options || []).join(", "));

  return (
    <div className="question-card">
      <div className="question-card_header">
        <h4>{CARD_HEADER_LABELS[question.type]}</h4>
        <div className="question-card_header_actions">
          {!isStructural && (
            <FormControlLabel
              control={
                <Checkbox
                  checked={!!question.required}
                  onChange={(e) => onUpdate(question.id, { required: e.target.checked })}
                  size="small"
                />
              }
              label="Required"
              className="question-card_required"
            />
          )}
          <Buttons icon={<ArrowUpwardIcon fontSize="small" />} ariaLabel="Move up" disabled={isFirst} onClick={() => onMove(index, -1)} />
          <Buttons icon={<ArrowDownwardIcon fontSize="small" />} ariaLabel="Move down" disabled={isLast} onClick={() => onMove(index, 1)} />
          <Buttons icon={<DeleteOutlineIcon fontSize="small" />} ariaLabel="Remove" onClick={() => onRemove(question.id)} className="question-card_header_remove" />
        </div>
      </div>

      <div className="question-card_body">
        {isSection && (
          <div className="question-card_field">
            <TextInput title="Section Title" name={`label-${question.id}`} value={question.label} onChange={(e) => onUpdate(question.id, { label: e.target.value })} multiline rows={2} />
          </div>
        )}

        {isInstruction && (
          <div className="question-card_field">
            <TextInput title="Instruction Text" name={`label-${question.id}`} value={question.label} onChange={(e) => onUpdate(question.id, { label: e.target.value })} multiline rows={2} />
          </div>
        )}

        {!isStructural && (
          <>

            <div className="question-card_field">
              <TextInput title="Participant Question" name={`text-${question.id}`} value={question.label} onChange={(e) => onUpdate(question.id, { label: e.target.value })} multiline rows={2} />
            </div>

            {isChoice && (
              <div className="question-card_field">
                <TextInput
                  title="Options (comma-separated)"
                  name={`options-${question.id}`}
                  value={optionsInput}
                  onChange={(e) => {
                    const raw = e.target.value;
                    setOptionsInput(raw);
                    onUpdate(question.id, { options: raw.split(",").map((o) => o.trim()).filter(Boolean) });
                  }}
                  placeholder="e.g. Yes, No, Unsure"
                />
              </div>
            )}

            {isRating && (
              <div className="question-card_row">
                <div className="question-card_col">
                  <TextInput title="Scale Min" name={`scaleMin-${question.id}`} value={question.scaleMin} onChange={(e) => onUpdate(question.id, { scaleMin: Number(e.target.value) || 0 })} />
                </div>
                <div className="question-card_col">
                  <TextInput title="Scale Max" name={`scaleMax-${question.id}`} value={question.scaleMax} onChange={(e) => onUpdate(question.id, { scaleMax: Number(e.target.value) || 0 })} />
                </div>
              </div>
            )}

            <div className="question-card_field">
              <TextInput
                title="Help Text / Clinical Guidance"
                name={`help-${question.id}`}
                value={question.helpText}
                onChange={(e) => onUpdate(question.id, { helpText: e.target.value })}
                placeholder="Optional guidance shown under the question"
              />
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default SurveyQuestionCard;
